import { render, staticRenderFns } from "./other.vue?vue&type=template&id=c3704048&scoped=true"
import script from "./other.vue?vue&type=script&lang=js"
export * from "./other.vue?vue&type=script&lang=js"
import style0 from "./other.vue?vue&type=style&index=0&id=c3704048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3704048",
  null
  
)

export default component.exports